export default __webpack_public_path__ + "6de4bf04bde44b4934344e76e8226879.png";